import React, { useState } from 'react';
import { adminAPI } from '../services/api';

export default function LoginPage({ onLogin }) {
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const res = await adminAPI.login(email, password);
      localStorage.setItem('air_admin_token', res.token);
      onLogin();
    } catch { setError('Invalid email or password.'); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center',
      background:'linear-gradient(155deg,#F0E4E3,#E8EEF5,#E4EEE8)', fontFamily:'Nunito,sans-serif' }}>
      <div style={{ background:'white', borderRadius:20, padding:40, width:360, boxShadow:'0 8px 40px rgba(0,0,0,.1)' }}>
        <div style={{ textAlign:'center', marginBottom:32 }}>
          <div style={{ width:60, height:60, borderRadius:'50%', background:'#F9EDEC', border:'2px solid #E8B4B1',
            display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 16px', fontSize:24 }}>🔐</div>
          <div style={{ fontFamily:'Playfair Display,serif', fontSize:24, fontWeight:700, color:'#2C2C35' }}>AIR Admin</div>
          <div style={{ fontSize:12, color:'#888899', marginTop:4 }}>All India Reporter — Admin Panel</div>
        </div>

        <form onSubmit={handleLogin}>
          <div style={{ marginBottom:16 }}>
            <label style={{ display:'block', fontSize:11, fontWeight:700, color:'#555567', marginBottom:6, textTransform:'uppercase', letterSpacing:1 }}>
              Email
            </label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)}
              placeholder="admin@example.com" autoFocus
              style={{ width:'100%', padding:'10px 14px', borderRadius:10, fontSize:14,
                fontFamily:'Nunito,sans-serif', color:'#2C2C35', outline:'none', boxSizing:'border-box',
                border: error ? '2px solid #FAE8E6' : '2px solid #E8E4DF' }}/>
          </div>
          <div style={{ marginBottom:16 }}>
            <label style={{ display:'block', fontSize:11, fontWeight:700, color:'#555567', marginBottom:6, textTransform:'uppercase', letterSpacing:1 }}>
              Password
            </label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)}
              placeholder="Enter password…"
              style={{ width:'100%', padding:'10px 14px', borderRadius:10, fontSize:14,
                fontFamily:'Nunito,sans-serif', color:'#2C2C35', outline:'none', boxSizing:'border-box',
                border: error ? '2px solid #FAE8E6' : '2px solid #E8E4DF' }}/>
          </div>
          {error && (
            <div style={{ color:'#C97B77', fontSize:12, marginBottom:12, padding:'8px 12px', background:'#F9EDEC', borderRadius:8 }}>
              {error}
            </div>
          )}
          <button type="submit" disabled={loading || !email || !password}
            style={{ width:'100%', padding:'12px', background:'#C97B77', color:'white', border:'none', borderRadius:10,
              fontSize:14, fontWeight:700, fontFamily:'Nunito,sans-serif',
              cursor: loading || !email || !password ? 'not-allowed' : 'pointer',
              opacity: loading || !email || !password ? .7 : 1 }}>
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}